import { axInstBasic } from "../../Service/Service";


export const fetchBarchatMonthData = async (parArn,childArn) => {
  // console.log(parArn,'-----sssss-------');
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getMileageKmplMonth`,{parArn,childArn}
    );
    // console.log(res,'-------------------');
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchBarchatDayData = async (parArn,childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getMileageKmplDay`,{parArn,childArn}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
// ----------------------------Line chart------------------------------
export const fetchLinehatSpeedMonthData = async (parArn,childArn) => {
 
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getEngineRuntimeHrsMonth`,{parArn,childArn}
    );
    
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchLinechatSpeedDayData = async (parArn,childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getEngineRuntimeHrsDays`,{parArn,childArn}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchLinehatMileageMonthData = async (parArn,childArn) => {
  // console.log(parArn,'-----sssss-------');
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getTotalDistMonth`,{parArn,childArn}
    );
    // console.log(res,'-------------------');
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchLinechatMileagDayData = async (parArn,childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getTotalDistDays`,{parArn,childArn}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};